import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaComments, FaTimes } from 'react-icons/fa';

const GradioChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Load Gradio script when component mounts
    const loadGradioScript = () => {
      // Since we're using iframe, we don't need the gradio.js script
      setIsLoaded(true);
    };

    loadGradioScript();
  }, []);

  return (
    <>
      {/* Chat Toggle Button */}
      <motion.div
        className="gradio-chat-toggle-btn"
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 2, duration: 0.5 }}
      >
        {isOpen ? <FaTimes /> : <FaComments />}
      </motion.div>

      {/* Chat Window */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="gradio-chat-window"
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ duration: 0.3 }}
          >
            {/* Chat Header */}
            <div className="gradio-chat-header">
              <div className="gradio-chat-header-info">
                <h4>Chat with Itrat</h4>
                <span>AI Assistant</span>
              </div>
              <button 
                className="gradio-chat-close-btn"
                onClick={() => setIsOpen(false)}
              >
                <FaTimes />
              </button>
            </div>

            {/* Gradio App Container */}
            <div className="gradio-chat-content">
              {isLoaded ? (
                <iframe
                  src="https://itratjassani-career-conversation.hf.space?__theme=soft&embed=true&container=false&info=false&show_api=false&show_footer=false&show_error=false&initial_height=300px"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  style={{ 
                    border: 'none',
                    borderRadius: '0 0 12px 12px',
                    background: 'white'
                  }}
                  title="Chat with Itrat"
                ></iframe>
              ) : (
                <div className="gradio-loading">
                  <div className="gradio-loading-spinner"></div>
                  <p>Loading chat interface...</p>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default GradioChat;